import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { setTitleCase } from "app/components/template/partials";
import dayjs from "dayjs";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { cancelSchedule } from "../../../../utils/action";

export function CancelSchedule() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [isLoading, setLoading] = useState(false);
  //   const [isCustomDate, setCustomDate] = useState(false);
  const showDialog = location.state?.showDialog ?? false;
  const scheduleData = location.state?.scheduleData ?? null;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleFormSubmit = async (values) => {
    setLoading(true);

    const request = {
      id: values.id,
      id_pelanggan: values.id_pelanggan,
    };

    // send to backend
    try {
      await cancelSchedule(request);
      toast.success(setTitleCase("berhasil membatalkan jadwal"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  const onHide = () => {
    navigate(-1);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-cancel-schedule-title"
      className="dialog-container"
    >
      <DialogTitle id="responsive-dialog-cancel-schedule-title">
        Batalkan Jadwal
      </DialogTitle>
      <Divider />

      <DialogContent className="dialog-content-column">
        <img
          src="/assets/images/alert.webp"
          width="30%"
          height="30%"
          alt="cancel-schedule images"
          loading="lazy"
        />
        <div className="dialog-content-spacing">
          <Grid container spacing={2} className="dialog-content-text">
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NAMA PELANGGAN
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {scheduleData.pelanggan?.nama_pelanggan}
              </Typography>
              <Divider />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                NO.TELEPON
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {scheduleData.pelanggan?.nomor_hp}
              </Typography>
              <Divider />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography className="dialog-content-key-text">
                JADWAL PENYEDOTAN
              </Typography>
              <Typography gutterBottom className="dialog-content-value-text">
                {dayjs(scheduleData.waktu_booking)
                  .locale("id")
                  .format("dddd, DD MMMM YYYY [pukul] HH:mm")}
              </Typography>
              <Divider />
            </Grid>
          </Grid>
        </div>
        <div className="dialog-content-spacing">
          <Typography className="dialog-confirm-text">
            Apakah anda yakin untuk membatalkan pesanan jadwal ?
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          autoFocus
          loading={isLoading}
          color="primary"
          variant="contained"
          onClick={() => handleFormSubmit(scheduleData)}
        >
          Batalkan Jadwal
        </LoadingButton>
        <Button autoFocus onClick={onHide} color="error" variant="contained">
          Kembali
        </Button>
      </DialogActions>
    </Dialog>
  );
}
